import Heading from "src/Pages/Company/Dashboard/components/Heading";
import { Paper, Stack } from "@mui/material";
import WidgetsForm from "src/Pages/Company/Dashboard/pages/Widgets/MainForm";

const Widgets = () => (
  <Stack spacing="1.5rem" data-testid="widgets-page">
    <Heading />
    <Paper sx={{ padding: "2rem" }} data-testid="widgets-page__content">
      <WidgetsForm />
    </Paper>
  </Stack>
);

export default Widgets;
